import apiBaseUrl from '../../utils/config.js';

class AppointmentsService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/appointments`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async request(endpoint, method, body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(`${this.baseUrl}${endpoint}`, options);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Request failed: ${errorText}`);
    }

    return await response.json();
  }

  async addAppointment(appointment) {
    return this.request("/add", "POST", appointment);
  }

  async getAllAppointments() {
    return this.request("/all", "GET");
  }

  async updateAppointment(id, appointment) {
    return this.request(`/update/${id}`, "PUT", appointment);
  }

  async deleteAppointment(id) {
    return this.request(`/delete/${id}`, "DELETE");
  }

  async getAppointmentsByOffice(officeId) {
    return this.request(`/office/${officeId}`, "GET");
  }

  async getAppointmentsByDoctor(doctorId) {
    return this.request(`/doctor/${doctorId}`, "GET");
  }

  async getAppointmentsByDiagComb(diagCombId) {
    return this.request(`/diag/${diagCombId}`, "GET");
  }

  async getAppointmentsByDate(date) {
    return this.request(`/date/${date}`, "GET");
  }

  async updateTypeVisit(id, oldVisit, newVisit) {
    const params = new URLSearchParams({ oldVisit, newVisit });
    return this.request(`/update-typevisit/${id}?${params.toString()}`, "PUT");
  }

  async getAvailableTimes(officeId, date) {
    return this.request(`/available-times?officeId=${officeId}&date=${date}`, "GET");
  }
}

export default AppointmentsService;
